import events from './events';
import Store from './store';
import * as Constants from './constants';
import setupOptions from './options';
import setupAPI from './api';
import ui from './ui';

export default class drawUtil {

    constructor(map, options) {

        options = setupOptions(options);

        const ctx = {
            options
        };
        this.ctx = ctx;

        let api = setupAPI(ctx, this);
        ctx.api = api;

        ctx.map = map;
        ctx.events = events(ctx);
        ctx.ui = ui(ctx);
        ctx.container = map.getContainer();
        ctx.store = new Store(ctx);

        if (ctx.options.boxSelect) {
            map.boxZoom.disable();
            // Need to toggle dragPan on and off or else first
            // dragPan disable attempt in simple_select doesn't work
            map.dragPan.disable();
            map.dragPan.enable();
        }

        /* if (map.loaded()) {
            this.connect();
        } */
        this.connect();

        ctx.events.start();
    }

    connect() {
        const { ctx } = this

        this.addLayers();
        this.updateLayersZIndexWapepr = () => {
            this.updateLayersZIndex()
        }

        ctx.map.on("layerAdded", this.updateLayersZIndexWapepr)
        ctx.map.on("layerMoved", this.updateLayersZIndexWapepr)

        ctx.store.storeMapConfig();
        ctx.events.addEventListeners();
    }

    addLayers() {
        const { ctx } = this
        // drawn features style
        ctx.map.addSource(Constants.sources.COLD, {
            data: {
                type: Constants.geojsonTypes.FEATURE_COLLECTION,
                features: []
            },
            buffer:512,
            type: 'geojson'
        });

        // hot features style
        ctx.map.addSource(Constants.sources.HOT, {
            data: {
                type: Constants.geojsonTypes.FEATURE_COLLECTION,
                features: []
            },
            buffer:512,
            type: 'geojson'
        });

        ctx.options.styles.forEach((style) => {
            ctx.map.addLayer(style);
        });

        ctx.store.setDirty(true);
        ctx.store.render();
    }

    updateLayersZIndex() {
        const { ctx } = this,
            map = ctx.map,
            styles = ctx.options.styles
        let { layers = [] } = map.getStyle();
        if (layers.length === 0 || layers[layers.length - 1].id === styles[styles.length - 1].id) return
        styles.forEach((style) => {
            if (map.getLayer(style.id)) {
                map.moveLayer(style.id, null, false);
            }
        });
    }

    removeLayers() {
        const { ctx } = this
        ctx.options.styles.forEach((style) => {
            if (ctx.map.getLayer(style.id)) {
                ctx.map.removeLayer(style.id);
            }
        });

        if (ctx.map.getSource(Constants.sources.COLD)) {
            ctx.map.removeSource(Constants.sources.COLD);
        }

        if (ctx.map.getSource(Constants.sources.HOT)) {
            ctx.map.removeSource(Constants.sources.HOT);
        }
    }

    destroy() {
        const { ctx } = this

        ctx.map.off("layerAdded", this.updateLayersZIndexWapepr)
        ctx.map.off("layerMoved", this.updateLayersZIndexWapepr)

        this.removeLayers();
        ctx.store.restoreMapConfig();
        ctx.events.removeEventListeners();
        ctx.map = null;
        ctx.container = null;
        ctx.store = null;
        return this;
    }
}
